<template>
  <div class="text-center">
    <v-avatar>
      <img src="https://vuetifyjs.com/apple-touch-icon-72x72.png" alt="avatar">
    </v-avatar>
  </div>
</template>

<script>
  export default {
    name: 'wh-logo'
  };
</script>